import http from '../common/http'

export const Login = params => (
	http.post('/account/login', params)
);
export const Register = params => (
	http.post('/account/register2', params)
);
//忘记密码
export const ForgetPwd = params => (
	http.post('account/forgetpwd', params)
);
//获取图片验证码
export const GetImgVerifyCode = params => (
	http.get('account/getimgverifycode', params)
);
export const GetSmsVerifyCode = params => (
	http.post('account/getsmsverifycode', params)
);
export const Logout = () => (
	http.post('/account/logout')
);
export const RefreshToken = token => (
	http.post('/account/refreshtoken', token)
);
export const GetUserInfo = () => (
	http.post('/account/getusernameandphoneinfo')
);
//注册
export const GetImgVerifyCodeForRegister = params => (
	http.get('account/GetImgVerifyCode2', params)
);
export const GetSmsVerifyCodeForRegister = params => (
	http.post('account/GetSmsVerifyCode2', params)
);
export const CheckRegiestMobile = params => (
	http.get('account/CheckRegiestMobile', params)
);
//获取用户中心菜单列表
export const GetUserMenus = () => (
	http.post('/account/GetUserMenus')
);
//返回sso登录地址
export const GetSSOLoginUrl = params => (
	http.get('/account/GetSSOLoginUrl', params)
);
//sso回调地址
export const LoginCallBack = params => (
	http.get('/account/LoginCallBack', params)
);
//解除绑定并退出登录
export const UnBind = params => (
	http.get('/account/UnBind', params)
);
//清除WEBApi服务缓存
export const ClearSession = params => (
	http.get('/account/ClearSession', params)
);
//dd鉴权回调地址
export const GetDDAuthority = params => (
	http.get('/account/GetDDAuthority', params)
);

//通过token获取用户信息
export const GetUserInfoByToken = params => (
	http.post('/account/GetUserInfoByToken', params)
);

export const GetSettlementUrl = ()=>(
	http.get('/account/GetSettlementUrl')
);

export const GetPolicy = params => (
	http.post('/nativeApp/GetPolicy', params)
);

export const GetAppMenuUrl = params => (
	http.post('/nativeApp/StoreMainInfo', params)
);

export const GetUserShops=params => (
	http.get('/nativeApp/Stores', params)
);




// WEBPACK FOOTER //
// ./src/api/userApi.js